module.exports = __webpack_public_path__ + "img/five-screen_content.f9d7c189.jpg";